import { render } from "./ProformaPdf.vue?vue&type=template&id=4782bdb9&scoped=true"
import script from "./ProformaPdf.vue?vue&type=script&lang=js"
export * from "./ProformaPdf.vue?vue&type=script&lang=js"

import "./ProformaPdf.vue?vue&type=style&index=0&id=4782bdb9&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4782bdb9"]])

export default __exports__